import { gql } from '@/__generated__';

export const UnauthenticatedTournamentQuery = gql(`
query UnauthenticatedTournamentQuery($id: ID!) {
  tournament(id: $id) {
    id
    name
    headline
    image {
     key
    }
    medals {
      ...MedalCardFragment
    }
    category
    managedBy {
      id
      username
    }
    ...TournamentStatusFragment
  }
}
`);
